import { ITreeViewModelConverter } from "../../Components/TreeView/Models/Interfaces/ITreeViewModelConverter";
import { ITreeNodeModel } from "../../Components/TreeView/Models/Interfaces/ITreeNodeModel";
import { TreeNodeModel } from "../../Components/TreeView/Models/TreeNodeModel";
import { ITreeField } from "./ITreeField";
import { CheckedState } from "../../Components/TreeView/Models/enums/CheckedState";

export class UsedFieldsConverter implements ITreeViewModelConverter {
    flatNodes: ITreeNodeModel[] = [];
    private useTreeFieldInlineEditFlag: boolean = false;

    constructor(useTreeFieldInlineEditFlag?: boolean) {
        if (useTreeFieldInlineEditFlag === true) {
            this.useTreeFieldInlineEditFlag = true;
        }
    }

    convertModel(model: any, selectedIds: number[]): ITreeNodeModel[] {
        let typedModel = model as ITreeField[];
        let tree: ITreeNodeModel[] = [];

        for (let item of typedModel) {
            this.addToTree(tree, item, undefined);
        }

        return tree;
    }

    addToTree(tree: ITreeNodeModel[], item: ITreeField, parent: ITreeNodeModel) {
        const node = new TreeNodeModel();
        node.businessModel = item;
        node.children = [];
        node.parent = parent;
        if (this.useTreeFieldInlineEditFlag) {
            node.selected = item.inlineEdit ? CheckedState.Checked : CheckedState.Unchecked;
        } else {
            node.selected = item.selected ? CheckedState.Checked : CheckedState.Unchecked;
        }
        tree.push(node);

        if (item.childs) {
            for (let sub of item.childs) {
                this.addToTree(node.children, sub, node);
            }
        }
    }

    getFlatNodes = (): ITreeNodeModel[] => {
        return this.flatNodes;
    }
}
